import { render, staticRenderFns } from "./InputCodeAddress.vue?vue&type=template&id=2c5cccff&"
import script from "./InputCodeAddress.vue?vue&type=script&lang=ts&"
export * from "./InputCodeAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports